import { data } from 'react-router'
import { requireAuthenticated } from '#app/utils/auth.server.ts'
import { getHints } from '#app/utils/client-hints.tsx'
import { getDateInUTCTime } from '#app/utils/date.ts'
import { prisma } from '#app/utils/db.server.ts'
import { getUserBranchId } from '#app/utils/organization.server.ts'
import { MoveAppointmentSchema } from '#app/utils/schemas/move-appointment-schema.tsx'
import { type Route } from './+types/move-appointment.tsx'

export async function action({ request }: Route.ActionArgs) {
	const { currentOrganizationId } = await requireAuthenticated(request)
	const branchId = await getUserBranchId(currentOrganizationId)

	const formData = await request.formData()
	const dataEntry = formData.get('data')
	if (typeof dataEntry !== 'string')
		return data({ error: 'missing data' }, { status: 400 })

	const parsedData = MoveAppointmentSchema.safeParse(JSON.parse(dataEntry))
	if (!parsedData.success)
		return data({ error: 'invalid data' }, { status: 400 })

	const { appointmentId, roomId, time, date, appointments } = parsedData.data

	const timeZone = getHints(request).timeZone

	const parsedDate = getDateInUTCTime(date, time, timeZone)

	const newRoomId = roomId === 'no-room' ? null : roomId

	await prisma.appointment.update({
		where: {
			id: appointmentId,
			organizationId: currentOrganizationId,
			branchId: branchId,
		},
		data: { roomId: newRoomId, date: parsedDate },
	})

	if (appointments && appointments.length > 0) {
		await prisma.appointment.updateMany({
			where: {
				id: {
					in: appointments
						.map((a) => a.id)
						.filter((id): id is string => typeof id === 'string'),
				},
				organizationId: currentOrganizationId,
				branchId: branchId,
			},
			data: { roomId: newRoomId },
		})
	}

	return { success: true }
}

export default () => null
